module.exports = __webpack_public_path__ + "static/media/insta.b75c4f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/insta.png
// module id = 362
// module chunks = 0